// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.linear-progress {
  
  display: inline-block;
 
  width: 17vw;
  align-items: center;
  height: 4px; /* Adjust the height as needed */
  background-color: transparent; /* Background color of the progress bar */
  
}

.linear-progress-bar {
  position: relative; /* Add relative positioning */
  height: 100%;
  align-items: center;
  border-radius: 0%;
  background-color: #ec2146; /* Color of the progress bar */
  transition: 0.001s ease-out; /* Adjust the transition duration as needed */
}

.linear-progress-bar::after {
  content: "";
  position: absolute;
  top: -5.5px;
  right: -3px;
  align-items: center;
  width: 12px; /* Adjust the size of the dot */
  height: 12px; /* Adjust the size of the dot */
  border-radius: 50%;
  background-color: #fff; /* Color of the dot */
  box-shadow: 0 0 8px 2px rgba(236, 33, 70, 0.8);
}

.linear-progress-text {
  font-family: Arial, sans-serif;
  font-size: 14px; /* Adjust the font size as needed */
  color: var(--text-color); /* Color of the progress text */
  text-align: start;
  line-height: 20px; /* Adjust the line height to vertically center the text */
}


@media(max-width:998px){
  .linear-progress {
    width: 170px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Linear/Linear.css"],"names":[],"mappings":";;AAEA;;EAEE,qBAAqB;;EAErB,WAAW;EACX,mBAAmB;EACnB,WAAW,EAAE,gCAAgC;EAC7C,6BAA6B,EAAE,yCAAyC;;AAE1E;;AAEA;EACE,kBAAkB,EAAE,6BAA6B;EACjD,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB,EAAE,8BAA8B;EACzD,2BAA2B,EAAE,6CAA6C;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW,EAAE,+BAA+B;EAC5C,YAAY,EAAE,+BAA+B;EAC7C,kBAAkB;EAClB,sBAAsB,EAAE,qBAAqB;EAC7C,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,eAAe,EAAE,mCAAmC;EACpD,wBAAwB,EAAE,+BAA+B;EACzD,iBAAiB;EACjB,iBAAiB,EAAE,yDAAyD;AAC9E;;;AAGA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["\n\n.linear-progress {\n  \n  display: inline-block;\n \n  width: 17vw;\n  align-items: center;\n  height: 4px; /* Adjust the height as needed */\n  background-color: transparent; /* Background color of the progress bar */\n  \n}\n\n.linear-progress-bar {\n  position: relative; /* Add relative positioning */\n  height: 100%;\n  align-items: center;\n  border-radius: 0%;\n  background-color: #ec2146; /* Color of the progress bar */\n  transition: 0.001s ease-out; /* Adjust the transition duration as needed */\n}\n\n.linear-progress-bar::after {\n  content: \"\";\n  position: absolute;\n  top: -5.5px;\n  right: -3px;\n  align-items: center;\n  width: 12px; /* Adjust the size of the dot */\n  height: 12px; /* Adjust the size of the dot */\n  border-radius: 50%;\n  background-color: #fff; /* Color of the dot */\n  box-shadow: 0 0 8px 2px rgba(236, 33, 70, 0.8);\n}\n\n.linear-progress-text {\n  font-family: Arial, sans-serif;\n  font-size: 14px; /* Adjust the font size as needed */\n  color: var(--text-color); /* Color of the progress text */\n  text-align: start;\n  line-height: 20px; /* Adjust the line height to vertically center the text */\n}\n\n\n@media(max-width:998px){\n  .linear-progress {\n    width: 170px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
